import React, { Fragment } from 'react';
import Breadcrumb from '../../../breadcrumb';
const Crumb = (props) => {
    const { crumbClickable, data, onClick } = props;
    const handleClick = (item) => onClick === null || onClick === void 0 ? void 0 : onClick(item);
    const renderHtml = () => {
        if (!data || !data.length) {
            return null;
        }
        return (React.createElement(Breadcrumb, null, data.map((item) => {
            return (React.createElement(Breadcrumb.Item, { key: item.key, onClick: () => handleClick(item) }, crumbClickable && item.data && item.data.target ? (React.createElement("a", null,
                item.icon,
                React.createElement("span", null, item.text))) : (React.createElement(Fragment, null,
                item.icon,
                React.createElement("span", null, item.text)))));
        })));
    };
    return renderHtml();
};
export default Crumb;
